/* RAVEN display-currency converter: display only, checkout always USD. */
(function () {
  var KEY = 'rd-currency', RKEY = 'rd-rates-v1';
  var FALLBACK = { USD: 1, EUR: 0.92, GBP: 0.79, CAD: 1.36, AUD: 1.52, JPY: 156, CHF: 0.88 };
  var cur = 'USD', rates = null, observing = false;
  try { cur = localStorage.getItem(KEY) || 'USD'; } catch (e) {}
  var origMap = new WeakMap(), outMap = new WeakMap();

  function loadRates(done) {
    try {
      var c = JSON.parse(localStorage.getItem(RKEY) || 'null');
      if (c && c.rates && Date.now() - c.ts < 12 * 3600 * 1000) { rates = c.rates; if (done) done(); return; }
    } catch (e) {}
    rates = FALLBACK;
    if (done) done();
    fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.rates) {
          rates = j.rates;
          try { localStorage.setItem(RKEY, JSON.stringify({ ts: Date.now(), rates: j.rates })); } catch (e) {}
          if (cur !== 'USD') convertAll();
        }
      })
      .catch(function () {});
  }

  function fmt(usd) {
    var r = (rates && rates[cur]) || FALLBACK[cur] || 1;
    var dec = cur === 'JPY' ? 0 : 2;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, minimumFractionDigits: dec, maximumFractionDigits: dec }).format(usd * r);
    } catch (e) {
      return (usd * r).toFixed(dec);
    }
  }

  var MONEY = /\$\s?([\d,]+(?:\.\d{1,2})?)/g;
  function convertLeaf(el) {
    var t = el.textContent;
    if (!t || t.indexOf('$') === -1) return;
    if (outMap.get(el) === t) return;
    var out = t.replace(MONEY, function (m, num) {
      var usd = parseFloat(String(num).replace(/,/g, ''));
      return isNaN(usd) ? m : fmt(usd);
    });
    if (out !== t) {
      if (!origMap.has(el)) origMap.set(el, t);
      outMap.set(el, out);
      el.textContent = out;
    }
  }

  function scan(root) {
    if (cur === 'USD' || !root || !root.querySelectorAll) return;
    var els = root.querySelectorAll('span, div, p, strong, b, td, dd, li, a, h1, h2, h3, h4, s, del, ins');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length > 0) continue;
      if (el.closest('script, style, .rd-drawer-locale, noscript')) continue;
      convertLeaf(el);
    }
  }

  function convertAll() { scan(document.body); }

  var timer = null;
  function observe() {
    if (observing || !window.MutationObserver) return;
    observing = true;
    new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () { timer = null; convertAll(); }, 160);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  window.rdCurrency = function () { return cur; };
  window.rdSetCurrency = function (code) {
    if (!code || (FALLBACK[code] === undefined && code !== 'USD')) return;
    try { localStorage.setItem(KEY, code); } catch (e) {}
    if (code === 'USD') { location.reload(); return; }
    cur = code;
    loadRates(function () { convertAll(); observe(); });
  };

  function boot() {
    if (cur === 'USD') return;
    loadRates(function () { convertAll(); observe(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
